// Copyright 2021 Sorama B.V.

import { bindable, bindingMode, computedFrom, customElement } from "aurelia-framework";

@customElement("simple-dropdown")
export class SimpleDropdown {
    //#region Bindable Properties
    @bindable({ defaultBindingMode: bindingMode.twoWay })
    public items: string[] = [];

    @bindable({ defaultBindingMode: bindingMode.twoWay })
    public selectedItem: string;

    @bindable({ defaultBindingMode: bindingMode.oneWay })
    public namePropertyName: "Name";

    @bindable({ defaultBindingMode: bindingMode.oneWay })
    public linePropertyNames: string[] = [];

    @bindable({ defaultBindingMode: bindingMode.oneWay })
    public disabled: false;
    //#endregion
    private searchText: string;

    //#region Computed Properties
    @computedFrom("items", "items.length", "searchText")
    public get filteredItems(): string[] {
        let items = [];
        if (this.items) {
            items = this.items.filter((item) => {
                return (
                    String(item[this.namePropertyName])
                        .toLowerCase()
                        .indexOf(String(this.searchText ? this.searchText : "").toLowerCase()) !== -1
                );
            });
        }

        // Sort alphabetically
        return items.sort((a: string, b: string) =>
            (a[this.namePropertyName] as string).localeCompare(b[this.namePropertyName] as string)
        );
    }
    //#endregion

    //#region Helper Methods
    private clearSearch = (event: MouseEvent): void => {
        event.stopPropagation();
        this.searchText = "";
    };
    //#endregion
}
